import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Amplify, Auth } from 'aws-amplify';
import { Authenticator, ThemeProvider, View, Heading, useTheme } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import './idreamrobots-theme.css';
import Dashboard from './components/Dashboard';
import ErrorBoundary from './components/ErrorBoundary';

// Configure Amplify
Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        region: process.env.REACT_APP_REGION,
        custom_header: async () => {
          try {
            const session = await Auth.currentSession();
            return {
              Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
              'Content-Type': 'application/json'
            };
          } catch (error) {
            console.error('Error getting session:', error);
            return {
              'Content-Type': 'application/json'
            };
          }
        }
      },
    ],
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_FILES_BUCKET,
      region: process.env.REACT_APP_REGION,
    },
  },
});

// Custom components for Authenticator
const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Heading level={3}>NumberSelect</Heading>
        <Heading level={5}>A serverless web application for number selection projects</Heading>
      </View>
    );
  },
};

// I Dream Robots Header Component
const IDreamRobotsHeader = () => (
  <header className="app-header">
    <nav className="app-nav">
      <a href="https://idreamrobots.com" className="app-logo">I Dream Robots</a>
      <ul className="app-nav-links">
        <li><a href="https://idreamrobots.com">Home</a></li>
        <li><a href="https://idreamrobots.com/about.html">About</a></li>
        <li><a href="https://idreamrobots.com/contact/">Contact</a></li>
      </ul>
    </nav>
  </header>
);

function App() {

  // Custom form fields for Authenticator
  const formFields = {
    signIn: {
      username: {
        placeholder: 'Enter your username',
        isRequired: true,
      },
      password: {
        placeholder: 'Enter your password',
        isRequired: true,
      },
    },
    setupNewPassword: {
      password: {
        placeholder: 'Enter your new password',
        isRequired: true,
      },
      confirmPassword: {
        placeholder: 'Confirm your new password',
        isRequired: true,
      },
    },
  };

  return (
    <BrowserRouter>
      <IDreamRobotsHeader />
      <main className="app-main">
        <ThemeProvider>
          <Authenticator
            formFields={formFields}
            components={components}
            hideSignUp={false}
          >
            {({ signOut, user }) => (
              <ErrorBoundary>
                <Routes>
                  <Route path="/profile" element={<Dashboard user={user} signOut={signOut} initialView="profile" />} />
                  <Route path="/projects/:projectId" element={<Dashboard user={user} signOut={signOut} initialView="project" />} />
                  <Route path="*" element={<Dashboard user={user} signOut={signOut} initialView="dashboard" />} />
                </Routes>
              </ErrorBoundary>
            )}
          </Authenticator>
        </ThemeProvider>
      </main>
    </BrowserRouter>
  );
}

export default App;
